export const FACEBOOK_URL = 'https://www.facebook.com/people/Ship-Sierra/pfbid02UEhk4zACWzuiH5c8cPHb9kX4HnGoaxmq86eRjrfDAEgzeYHRTgYGUHXZmT1r5RZQl/';
export const INSTAGRAM_URL = 'https://www.instagram.com/shipsierradotcom/';
export const THREADS_URL = 'https://www.threads.com/@shipsierradotcom';
export const TIKTOK_URL = 'https://www.tiktok.com/@shipsierra.com/';
export const X_URL = 'https://x.com/shipsierra';
export const YOUTUBE_URL = 'https://www.youtube.com/channel/UC315lxjpttDCyCxq5GZU5XQ';